
// ==========================================
// 12. src/App.js - MAIN APPLICATION
// ==========================================
import React, { useEffect } from 'react';
import Navigation from './components/layout/Navigation';
import Hero from './components/sections/Hero';
import ProblemSection from './components/sections/ProblemSection';
import GuideSection from './components/sections/GuideSection';
import SolutionSection from './components/sections/SolutionSection';
import HowItWorks from './components/sections/HowItWorks';
import SuccessSection from './components/sections/SuccessSection';
import CTASection from './components/sections/CTASection';
import Footer from './components/layout/Footer';
import AboutSection from './components/sections/AboutSection';
import VisionSection from './components/sections/VisionSection';
import TeamSection from './components/sections/TeamSection';
import BackToTop from './components/layout/BackToTop';
import StandardsSection from './components/sections/StandardsSection';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ProblemSection />
      <GuideSection />
      <SolutionSection />
      <StandardsSection />
      <HowItWorks />
      <SuccessSection />
      <CTASection />
      <AboutSection />
      <TeamSection />
      <VisionSection />
      <Footer />
      <BackToTop/>
    </div>
  );
}

export default App;